import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import * as i1$1 from '@angular/forms';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from 'reference-library';
import { CommonModule } from '@angular/common';

class FbEmailContentService {
    constructor(http) {
        this.http = http;
    }
    getEmailReminders(Id) {
        return this.http.get(`/vd/formBuilder/client/invoice/${Id}/remainder/details`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return null;
            }
        }));
    }
}
FbEmailContentService.ɵfac = function FbEmailContentService_Factory(t) { return new (t || FbEmailContentService)(i0.ɵɵinject(i1.HttpClient)); };
FbEmailContentService.ɵprov = i0.ɵɵdefineInjectable({ token: FbEmailContentService, factory: FbEmailContentService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbEmailContentService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class FbEmailContentComponent {
    constructor(fb, referenceLibraryService, fbEmailContentService) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.fbEmailContentService = fbEmailContentService;
        this.observableSubscription$ = new Subject();
        this.emailContent = "<strong>Email Content will be displayed here</strong>";
    }
    ngOnInit() {
        if (this.inputParams.name === "INVOICE_EMAIL_CONTENT") {
            this.getEmailReminderDetails();
        }
        else {
            this.referenceLibraryService
                .getDataSource('FB_ONB_WELCOME_EMAIL_SETUP', '')
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((response) => {
                var _a;
                this.emailContent = (_a = response[0]) === null || _a === void 0 ? void 0 : _a.description;
            });
        }
        this.group.addControl(this.inputParams.name, this.fb.control(this.emailContent));
    }
    getEmailReminderDetails() {
        this.getListId = 'idToGetDetails' in sessionStorage ? parseInt(sessionStorage.getItem('idToGetDetails')) : null;
        if (this.getListId) {
            this.fbEmailContentService.getEmailReminders(this.getListId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                this.emailContent = response.data.remainderEmailContent || null;
            });
        }
    }
}
FbEmailContentComponent.ɵfac = function FbEmailContentComponent_Factory(t) { return new (t || FbEmailContentComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(FbEmailContentService)); };
FbEmailContentComponent.ɵcmp = i0.ɵɵdefineComponent({ type: FbEmailContentComponent, selectors: [["lib-fb-email-content"]], inputs: { inputParams: "inputParams", group: "group", formControlName: "formControlName" }, decls: 2, vars: 1, consts: [[1, "textAreaContainer"], [3, "innerHTML"]], template: function FbEmailContentComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelement(1, "div", 1);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("innerHTML", ctx.emailContent, i0.ɵɵsanitizeHtml);
    } }, styles: [".textAreaContainer[_ngcontent-%COMP%]{border:1px solid #ccc;padding:5px;max-width:100%;height:auto;resize:both;overflow:auto}.textAreaContainer[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{min-height:30px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbEmailContentComponent, [{
        type: Component,
        args: [{
                selector: 'lib-fb-email-content',
                templateUrl: 'fb-email-content.component.html',
                styleUrls: ['fb-email-content.component.scss']
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.ReferenceLibraryService }, { type: FbEmailContentService }]; }, { inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], formControlName: [{
            type: Input
        }] }); })();

class FbEmailContentModule {
}
FbEmailContentModule.ɵfac = function FbEmailContentModule_Factory(t) { return new (t || FbEmailContentModule)(); };
FbEmailContentModule.ɵmod = i0.ɵɵdefineNgModule({ type: FbEmailContentModule });
FbEmailContentModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            FormsModule,
            ReactiveFormsModule,
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(FbEmailContentModule, { declarations: [FbEmailContentComponent], imports: [FormsModule,
        ReactiveFormsModule,
        CommonModule], exports: [FbEmailContentComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FbEmailContentModule, [{
        type: NgModule,
        args: [{
                declarations: [FbEmailContentComponent],
                imports: [
                    FormsModule,
                    ReactiveFormsModule,
                    CommonModule
                ],
                exports: [FbEmailContentComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of fb-email-content
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FbEmailContentComponent, FbEmailContentModule, FbEmailContentService };
//# sourceMappingURL=fb-email-content.js.map
